import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  UPLOAD_BUTTON: `${cleanedFilename(__filename)}-upload-button`,
};
